"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isBrowser = _interopRequireDefault(require("./isBrowser"));

var now;

if (_isBrowser["default"] && window.performance && window.performance.now) {
  now = function now() {
    return performance.now();
  };
} else {
  var loadTime = Date.now();

  now = function now() {
    return Date.now() - loadTime;
  };
}

var _default = now;
exports["default"] = _default;
module.exports = exports.default;